import * as actionTypes from './actionTypes';


const initialState = {
    otp:'',
    currentTime:'',
    username:'',
};

export default function ForgotPassReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_OTP:
      return {
        ...state,
        otp: action.payload.otp,
        currentTime: action.payload.currentTime,
        username: action.payload.username
      };

    case actionTypes.RESET_OTP:
      return {
        ...state,
        otp: '',
        currentTime: '',
        username: ''
      };

    default:
      return state;
  }
}
